var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"w-100 f6 mt0-l mt4 ph4-l ph3"},[_c('article',{staticClass:"bg-white mh5-l mh0"},[_c('div',{staticClass:"ph5-l ph4 pv3"},[(_vm.isPasswordReset)?_c('password-reset'):_c('password-reset-success')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }